<template>
	<section class="open-search">
		<section class="search-box">
			<input v-model="searchText" type="text" placeholder="Pesquisa rápida" @keydown.enter="search" />

			<button type="button" @click="search">
				<i class="far fa-search" />
			</button>
		</section>

		<section :class="open ? 'active' : ''" class="search-modal">
			<section class="header">
				<section class="search">
					<div class="search-box-big">
						<section class="icon" @click="search">
							<i class="fal fa-search" />
						</section>

						<section class="field">
							<input type="text" v-model="searchText" placeholder="Pesquisa rápida" @keydown.enter="search" />
						</section>

						<!-- <div class="filters active">
							<button type="button" @click="filtersToggle">Filtros <i class="fas fa-caret-down"></i></button>

							<section class="options" v-show="filters">
								<ul>
									<li>
										<ui-checkbox design="xs" label="Usuários" />
									</li>

									<li>
										<ui-checkbox design="xs" label="Clientes" />
									</li>

									<li>
										<ui-checkbox design="xs" label="Empreendimentos" />
									</li>

									<li>
										<ui-checkbox design="xs" label="Ferramentas" />
									</li>

									<li>
										<ui-checkbox design="xs" label="Negócios" />
									</li>

									<li>
										<ui-checkbox design="xs" label="E-mails" />
									</li>

									<li>
										<ui-checkbox design="xs" label="Configurações" />
									</li>
								</ul>

								<section class="control">
									<button>Selecionar tudo</button>
								</section>
							</section>
						</div> -->
					</div>
				</section>

				<section class="modal-control">
					<button type="button" @click="close">
						<i class="fal fa-times"></i>
					</button>
				</section>
			</section>

			<section class="body">
				<ui-overlay-load v-if="load" />

				<section v-else class="results">
					<div class="title-total-results">
						<div class="title"><h2>Clientes</h2></div>
						<span v-if="data.deals.length > 0" class="total-search">Estes são os  {{data.deals.length}} itens encontrados mais relevantes.</span>
						<div v-if="data.deals.length" class="info" @mouseover="show = true" @mouseout="show = false">
							<i class="fal fa-info-circle"></i>
							<div v-if="show" class="tooltip">
								A busca irá trazer apenas os 25 primeiros resultados.
							</div>
						</div>
					</div>
					<div v-if="data.deals.length" class="items">
						<div v-for="(deal, index) in data.deals" :key="index">
							<ui-search-deals-card :data="deal" />
						</div>
					</div>

					<div v-else>
						Nenhum negócio encontrado!
					</div>

					<!-- <h2>Pessoas</h2>
					<div class="items">
						<div v-for="(user, index) in data.users" :key="index">
							<ui-search-users-card :data="user" />
						</div>
					</div>

					<h2>Empreendimentos</h2>
					<div class="items">
						<div v-for="(product, index) in data.products" :key="index">
							<ui-search-properties-card :data="product" />
						</div>
					</div> -->
				</section>
			</section>

			<section class="footer"></section>
		</section>
	</section>
</template>

<script>
	import uiSearchDealsCard from '@/components/ui-facilita/search-deal-card'
	// import uiSearchUsersCard from '@/components/ui-facilita/search-users-card'
	// import uiSearchPropertiesCard from '@/components/ui-facilita/search-properties-card'
	// import { uiCheckbox } from '@/components/ui/form'
	import { uiOverlayLoad } from '@/components/ui'

	import { openSearch } from '@/services/axios'
	import helpers from '@/mixins/helpers'

	import { mapGetters } from 'vuex'

	export default {
        name: 'ui-open-search',

		components: {
			uiSearchDealsCard,
			// uiSearchUsersCard,
			// uiSearchPropertiesCard,
			// uiCheckbox,
			uiOverlayLoad
		},
		mixins: [ helpers ],
		data(){
			return {
				show: false,
				searchText: '',
				searchTimeout: null,
				open: false,
                filters: false,
				load: false,
				data: {
					deals: [],
					products: [],
					users: []
				},
				unsubscribe: null
			}
		},

		created() {
			/** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (mutation.type === 'openSearch/SET_QUERY') {
                    this.searchText = this.query
					this.search()
                }
            })

			document.addEventListener('keydown', this.onEscape)
		},

		beforeDestroy() {
			this.unsubscribe()
			document.removeEventListener('keydown', this.onEscape)
		},

		computed: {
			...mapGetters('openSearch', {
				query: 'getQuery',
				redirect: 'getRedirect'
			})
		},

		methods: {
			/**
			 * Realiza a busca do termo pesquisado via OpenSearch
			 */
			search() {
                if(this.load) return;
				this.open = true
				this.$set(this.data, 'deals', [])
				this.$set(this.data, 'products', [])
				this.$set(this.data, 'users', [])
				this.load = true
				this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: 'open-search',
                    action: "click",
                    label: 'Abrir modal de pesquisa',
                })
				openSearch.search(this.searchText, this.getInstance())
					.then(response => {
						const deals = Object.values(response.data.hits.hits)
							.map(item => {
								return { ...item._source, _score: item._score }
							})
							.sort((a, b) => {
								return parseFloat(a._score) - parseFloat(b._score)
							})
						this.$set(this.data, 'deals', deals)
					})
					.catch(error => {
						console.log(error)
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.load = false
					})
			},
			/**
			 * Fecha o modal e limpa os dados da última busca
			 */
			close() {
				this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: 'open-search',
                    action: "click",
                    label: 'Clique cancelar ação',
                })
				if (this.redirect) {
					this.$store.dispatch('openSearch/setRedirect', false)
					this.$router.push('/vendas/negocios/lista')

				} else {
					this.$set(this.data, 'deals', [])
					this.$set(this.data, 'products', [])
					this.$set(this.data, 'users', [])
					this.open = false
					this.searchText = ''
				}
			},
			/**
			 * Marca ou desmarca todos os filtros
			 */
            filtersToggle() {
                this.filters = !this.filters
            },
			/**
			 * Função auxiliar que trata o evento de quando uma tecla é pressionada
			 * para verificar se foi a tecla esc e então fechar o modal
			 */
			onEscape(e) {
				if (this.open && e.keyCode === 27) this.close()
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>